var exports = {
  "j": "Modals.module__modals___UmVjdW",
};

module.exports = exports;
